export enum ProductButtonState {
    UNAVAILABLE = 'UNAVAILABLE',
    LAUNCH = 'LAUNCH',
    RESUME = 'RESUME',
    REPAIR = 'REPAIR',
    INSTALLING = 'INSTALLING',
    UPDATE = 'UPDATE',
    QUEUED = 'QUEUED',
    INSTALL = 'INSTALL',
    RUNNING = 'RUNNING',
    WAITING = 'WAITING',
    BANNED = 'BANNED',
    GET = 'GET'
}

export default ProductButtonState;
